import React from 'react';
import PropTypes from 'prop-types';
import CurrentLevelStyled from './CurrentLevel.styled';

const CurrentLevel = ({ currentLevel }) => (
  <CurrentLevelStyled>
    Level <span>{currentLevel + 1}</span>
  </CurrentLevelStyled>
);

export default CurrentLevel;

CurrentLevel.propTypes = {
  currentLevel: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/CurrentLevel/CurrentLevel.js